// src/pages/client/ClientFolderTable.js
import React, { useEffect, useState } from 'react';
import api from "../api";

export default function ClientFolderTable({ collection }) {
  const [entries, setEntries] = useState([]);
  const token = localStorage.getItem('token');
  // const userEmail = localStorage.getItem('userEmail'); // make sure this is stored at login

  useEffect(() => {
    fetchEntries();
  }, [collection]);

  const fetchEntries = async () => {
    try {
      const res = await api.get(`/lm/${collection}`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      setEntries(res.data.entries || []);
    } catch (err) {
      console.error("Error fetching client entries:", err);
    }
  };

  return (
    <div className="lm-table">
      <h3>{collection.replace("lm_", "").toUpperCase()} Records</h3>
      <table className="lm-data-table">
        <thead>
          <tr>
            <th>Date</th>
            <th>Name</th>
            <th>Note</th>
            <th>File</th>
          </tr>
        </thead>
        <tbody>
          {entries.map((entry) => (
            <tr key={entry.id}>
              <td>{entry.date}</td>
              <td>{entry.name}</td>
              <td>{entry.note}</td>
              <td>
                {entry.file_url ? (
                  <a href={entry.file_url} target="_blank" rel="noreferrer">{entry.filename}</a>
                ) : "—"}
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
